// extracted by mini-css-extract-plugin
module.exports = {"GenericContentWrapper":"GenericContentWrapper_GenericContentWrapper__2YWEA"};